import React from "react";
import { Box } from "@mui/material";
import LandingHeader from "./LandingHeader";
import { colors } from "../theme/theme";

const LandingLayout = ({ hero, children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: colors.primary,
      }}
    >
      <LandingHeader />
      {hero}
      <Box sx={{ px: { xs: 2, md: 4 }, py: 3 }}>{children}</Box>
    </Box>
  );
};

export default LandingLayout;
